/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: "eu-west-3",
    aws_cognito_identity_pool_id: import.meta.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    aws_cognito_region: "eu-west-3",
    aws_user_pools_id: import.meta.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
    aws_user_pools_web_client_id: import.meta.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    oauth: {
        "domain": import.meta.env.REACT_APP_SSO_URL,
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    aws_cognito_username_attributes: ["EMAIL"],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ["EMAIL"],
    aws_cognito_mfa_configuration: "OFF",
    aws_cognito_mfa_types: ["SMS"],
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ["EMAIL"],
    aws_cloud_logic_custom: [
        {
            name: "crealoapi",
            endpoint: import.meta.env.REACT_APP_AWS_API_ENDPOINT,
            region: "eu-west-3",
        },
    ],
};

export default awsmobile;
